import React from "react";
import { connect } from "react-redux";
import Header from "../Header.js";
import { ProgressSpinner } from "primereact/progressspinner";
import Form from "../Form.js";
import { Button } from "primereact/button";
import LoginBox from "./../LoginBox.js";
import { Dialog } from "primereact/dialog";
import Server from "../Server.js";

class Club extends React.Component {
  constructor(props) {
    super(props);

    this.Server = new Server();

    this.state = {
      ShowLoading: false,
      absoluteUrl: this.Server.getAbsoluteUrl(),
      url: this.Server.getUrl(),
      getUserData: 1
    };
  }

  ConvertNumToFarsi(text) {
    var id = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    if (!text) return text;
    return text.toString().replace(/[0-9]/g, function (w) {
      return id[+w];
    });
  }
  componentDidMount() {
   this.GetAccounts();
  }

  
  GetAccounts(){
   
    let that = this;
    let SCallBack = function(response){
      let data=[];
      let condition=[];
      let resp=[];    
     for(let i=0;i<response.length;i++){
       resp[i] = response[i].children;
      
     }
     for(let i=0;i<resp.length;i++){
      let Mnd = "";
      let Kind = "";
      let Number = "";
      for(let j=0;j<resp[i].length;j++){
        if(resp[i][j].name=="A_Mnd"){
          Mnd = resp[i][j].value
        }
        if(resp[i][j].name=="A_Kind"){
          Kind = resp[i][j].value
        }
        if(resp[i][j].name=="A_Accx"){
          Number = resp[i][j].value
        }

      }
      data.push({
        "Mnd":Mnd,
        "Kind":Kind,
        "Number": Number
      })    
      condition.push({
        "Kind":Kind,
        "Number": Number
      })      
     }
     that.updateAccs(data, condition);
    } 
    let ECallBack = function(error){
    }
    
    var param = '{CommandNo : "3" , AccountNo: "' + that.props.account + '",Param1: "' + that.props.password + '" }';
    let ip = that.props.ip || "https://ansar24.com";

    that.Server.sendRaymand(""+ip+"/MobileBank.aspx/MobileBankSp",param,SCallBack,ECallBack,{
      ip: that.props.ip
  })
  }


  render() {
    return !this.state.ShowLoading ? (
      <div className="sarv-bg1 sarv-home-top-box" style={{ height: "100%" }}>
        <Header ComponentName="باشگاه مشتریان" />

        <p style={{textAlign:'center',direction:'rtl',marginTop:100}}>
          <p>درحال پیاده سازی ...</p>
        </p>
      </div>
    ) : (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <ProgressSpinner
          style={{ width: "50px", height: "50px" }}
          strokeWidth="2"
          fill="var(--surface-ground)"
          animationDuration=".5s"
        />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    appData: state.appData,
    creditPrice: state.creditPrice,
    systemId: state.systemId,
  };
}
export default connect(mapStateToProps)(Club);
